/* Why rows: the button scrolls to the buy box, photo galleries move one photo at a time,
   and the underlined end of the title draws in when it scrolls into view. */
(function () {
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var behavior = reduceMotion ? 'auto' : 'smooth';

  function initButton(root) {
    var btn = root.querySelector('[data-fm-why-cta]');
    if (!btn) return;
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      // The target setting can hold several selectors. Scroll to the first one that is on screen.
      var list = (btn.getAttribute('data-target') || '') + ', form[action*="/cart/add"]';
      var target = null;
      list.split(',').some(function (sel) {
        sel = sel.trim();
        if (!sel) return false;
        try {
          var el = document.querySelector(sel);
          if (el && el.getBoundingClientRect().height > 0) { target = el; return true; }
        } catch (err) {}
        return false;
      });
      if (!target) return;
      // 78px is where the original stops: the sticky header stays clear of the buy box.
      var y = target.getBoundingClientRect().top + window.pageYOffset - 78;
      window.scrollTo({ top: y, behavior: behavior });
    });
  }

  function initGallery(gal) {
    var track = gal.querySelector('[data-fm-why-track]');
    var prev = gal.querySelector('[data-fm-why-prev]');
    var next = gal.querySelector('[data-fm-why-next]');
    var dots = [].slice.call(gal.querySelectorAll('.fm-why__gal-dots i'));
    if (!track) return;
    function width() { return track.clientWidth || 1; }
    function sync() {
      var at = Math.round(track.scrollLeft / width());
      dots.forEach(function (dot, i) { dot.classList.toggle('is-on', i === at); });
    }
    track.addEventListener('scroll', sync, { passive: true });
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -width(), behavior: behavior }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: width(), behavior: behavior }); });
  }

  function initHighlights(root) {
    var marks = [].slice.call(root.querySelectorAll('.fm-why__hl'));
    if (!marks.length) return;
    if (reduceMotion || !('IntersectionObserver' in window)) {
      marks.forEach(function (m) { m.classList.add('is-in'); });
      return;
    }
    var seen = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-in');
        seen.unobserve(entry.target);
      });
    }, { threshold: 0.4 });
    marks.forEach(function (m) { seen.observe(m); });
  }

  function init(root) {
    if (root.hasAttribute('data-pdp-ready')) return;
    root.setAttribute('data-pdp-ready', '');
    initButton(root);
    root.querySelectorAll('[data-fm-why-gal]').forEach(initGallery);
    initHighlights(root);
  }

  function boot() { document.querySelectorAll('[data-pdp-why-rows]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
